import React, { useEffect, useState } from 'react'
import { CCard, CCardBody } from '@coreui/react-pro'
import EmailQuotaService from 'src/service/EmailQuotaService'
import EmailQuotaPanel from './EmailQuotaPanel'
import FantasyRoundEmailLog from './FantasyRoundEmailLog'
import SentMemberEmailLog from './SentMemberEmailLog'
import './GameNotification.css'

// Tab labels stay short so all six fit one strip; the full name is in the panel heading.
const TABS = [
  {
    key: 'round_reminder',
    label: 'Round Reminder',
    title: 'Fantasy Round Reminder',
    note: 'Sent before each round locks, reminding members to pick their team.',
    countKey: 'fantasyRoundReminderCount',
    emailType: 1,
  },
  {
    key: 'round_results',
    label: 'Round Results',
    title: 'Fantasy Round Results & Reminder',
    note: 'Sent after each round is scored, with results and a nudge towards the next round.',
    countKey: 'fantasyResultCount',
    emailType: 2,
  },
  {
    key: 'top_managers',
    label: 'Top Managers',
    title: 'Top 10 Managers (Overall)',
    note: "The overall leaderboard's top ten managers.",
    countKey: 'getTopManagerCount',
    emailType: 4,
  },
  {
    key: 'top_players',
    label: 'Top Players',
    title: 'Top 10 Players (Overall)',
    note: 'The ten highest-scoring players across the season.',
    countKey: 'getTopPlayerCount',
    emailType: 3,
  },
  {
    key: 'final_result',
    label: 'Final Result',
    title: 'Announce Final Result',
    note: 'The closing email with final standings and the winner.',
    countKey: 'finalResultCount',
    emailType: 6,
  },
  {
    key: 'member_emails',
    label: 'Member Emails',
    title: 'Member Emails',
    note: 'Messages you wrote and sent to individual members.',
    countKey: 'gameMemberEmailCount',
  },
]

const EmailTrack = () => {
  const [activeTab, setActiveTab] = useState(TABS[0].key)
  const [alertCount, setAlertCount] = useState({})

  useEffect(() => {
    EmailQuotaService.getEmailAlertCount().then((res) => {
      if (res.status === 200) {
        setAlertCount(res.data)
      }
    })
  }, [])

  const active = TABS.find((tab) => tab.key === activeTab) || TABS[0]

  return (
    <>
      <div className="ge-page-header">
        <h1 className="ge-page-title">Email Activity</h1>
        <p className="ge-page-subtitle">Every email this game has sent, and who received it.</p>
      </div>

      <EmailQuotaPanel />

      <div className="ge-tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.key}
            className={`ge-tab${activeTab === tab.key ? ' active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
            <span className="ge-tab-count">{alertCount?.[tab.countKey] ?? 0}</span>
          </button>
        ))}
      </div>

      <CCard className="gn-panel">
        <CCardBody>
          <div className="gn-panel-head">
            <h2 className="gn-panel-title">{active.title}</h2>
            <p className="gn-panel-note">{active.note}</p>
          </div>

          {active.emailType ? (
            <FantasyRoundEmailLog key={active.emailType} emailType={active.emailType} />
          ) : (
            <SentMemberEmailLog />
          )}
        </CCardBody>
      </CCard>
    </>
  )
}

export default EmailTrack
